import { ScheduledPaymentsPage, PageContainer } from "../components";

export const ScheduledPayments = () => {
  return (
    <PageContainer title="پرداخت های برنامه ریزی شده">
      <ScheduledPaymentsPage />
    </PageContainer>
  );
};
